var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 78.5,
    height: 78.5,
    rx: 39.25,
    fill: "#9CA3AF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 78.5,
    height: 78.5,
    rx: 39.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8002 40.0002C52.8002 43.2779 51.4516 46.4214 49.0512 48.7391C46.6507 51.0568 43.395 52.3588 40.0002 52.3588C36.6054 52.3588 33.3497 51.0568 30.9492 48.7391C28.5488 46.4214 27.2002 43.2779 27.2002 40.0002C27.2002 36.7225 28.5488 33.579 30.9492 31.2614C33.3497 28.9437 36.6054 27.6416 40.0002 27.6416C43.395 27.6416 46.6507 28.9437 49.0512 31.2614C51.4516 33.579 52.8002 36.7225 52.8002 40.0002ZM43.2002 35.3657C43.2002 36.1852 42.8631 36.971 42.2629 37.5505C41.6628 38.1299 40.8489 38.4554 40.0002 38.4554C39.1515 38.4554 38.3376 38.1299 37.7375 37.5505C37.1373 36.971 36.8002 36.1852 36.8002 35.3657C36.8002 34.5463 37.1373 33.7604 37.7375 33.181C38.3376 32.6016 39.1515 32.2761 40.0002 32.2761C40.8489 32.2761 41.6628 32.6016 42.2629 33.181C42.8631 33.7604 43.2002 34.5463 43.2002 35.3657ZM40.0002 41.545C38.4684 41.5448 36.9686 41.9691 35.6793 42.7676C34.3899 43.5662 33.3651 44.7053 32.7266 46.0498C33.6269 47.061 34.743 47.8723 35.9985 48.428C37.254 48.9837 38.6191 49.2706 40.0002 49.2692C41.3813 49.2706 42.7464 48.9837 44.0019 48.428C45.2574 47.8723 46.3735 47.061 47.2738 46.0498C46.6353 44.7053 45.6105 43.5662 44.3211 42.7676C43.0318 41.9691 41.532 41.5448 40.0002 41.545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.a4209006ff6194644a5bd42481dbe645.svg";
export { ForwardRef as ReactComponent };